import { TableOrder } from '../../features/orders';

const Orders = () => {
  return <TableOrder />;
};

export default Orders;
